// Determines the status on the splash screen, login
export const getSplashStatus = (authToken?: string) => {
  if (authToken) return "Configuring ADFS login...";
  return "Checking if ADFS is enabled...";
};
